import React from 'react'

const Adminpage = () => {
    return (
        <div>

        </div>
    )
}

export default Adminpage
